/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Button } from '@mui/material';
import RoleCreation from './RoleCreation';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';

const RoleCreationBtn = () => {
    const [openRoleCreationModal, setOpenRoleCreationModal] = useState(false);
    const handleCloseDialog = () => {
        setOpenRoleCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{ background: (theme) => theme.palette.gradiant.main, float: 'right' }}
                onClick={() => setOpenRoleCreationModal(true)} >Register Role</Button>
            <DialogContainer
                open={openRoleCreationModal}
                handleClose={handleCloseDialog}
            >
                <RoleCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default RoleCreationBtn;
